<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="rmfarm" title="솔루션" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                스마트팜 제품 솔루션
            </template>
            <tit-wrap-large>
                한국형 농가 맞춤 <b>배지함수율 측정장치</b>
                <template #text> 한국형 배지치수에 적용 가능한 제품으로 작물의 뿌리 주변의 함수율 제공하여 <br class="d-none d-lg-block" />작물의 품질향상과 수확량을 증대를 도와줍니다. </template>
            </tit-wrap-large>

            <v-img max-width="794" :aspect-ratio="794 / 378" src="/images/sub/solution/smartfarm/rmfarm-img.png" class="mx-auto" data-aos="fade" data-aos-delay="100" />
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section>
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <tit-wrap-large class="tit-wrap--lg">
                        <b>혁신성과 기술력을 인정받은 알엠팜</b>
                        <template #text> 알엠팜은 조달청 혁신장터에 등록되어 있는 우수 연구개발 혁신 제품으로 <br class="d-none d-lg-block" />국내 농업환경에 가장 최적화 되어있습니다. </template>
                    </tit-wrap-large>

                    <v-row class="row--lg">
                        <v-col cols="12" md="6" lg="4" data-aos="fade-left" data-aos-delay="100">
                            <v-card rounded="" color="grey lighten-5">
                                <v-responsive :aspect-ratio="374 / 298" content-class="d-flex pa-20px">
                                    <v-img max-width="270" :aspect-ratio="270 / 68" src="/images/sub/solution/smartfarm/rmfarm-img2.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                            <div class="mt-20px mt-md-40px">
                                <tit-wrap-sprout>
                                    알엠팜 고급형
                                </tit-wrap-sprout>

                                <txt-item>
                                    <template #title>측정항목</template>
                                    실시간 무게, 급액량, 배액량, 배액EC, 배액pH, 배지온도, <br class="d-none d-lg-block" />온도, 습도
                                </txt-item>

                                <txt-item>
                                    <template #title>적용분야</template>
                                    파프리카, 토마토, 딸기 등 <br class="d-none d-lg-block" />시설재배 작물
                                </txt-item>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade-left" data-aos-delay="200">
                            <v-card rounded="" color="grey lighten-5">
                                <v-responsive :aspect-ratio="374 / 298" content-class="d-flex pa-20px">
                                    <v-img max-width="304" :aspect-ratio="304 / 90" src="/images/sub/solution/smartfarm/rmfarm-img3.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                            <div class="mt-20px mt-md-40px">
                                <tit-wrap-sprout>
                                    알엠팜 기본형
                                </tit-wrap-sprout>

                                <txt-item>
                                    <template #title>측정항목</template>
                                    실시간 무게, 급액량, 배액량, <br class="d-none d-lg-block" />배액EC, 배액pH
                                </txt-item>

                                <txt-item>
                                    <template #title>적용분야</template>
                                    파프리카, 토마토 등 <br class="d-none d-lg-block" />시설재배 작물
                                </txt-item>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade-left" data-aos-delay="300">
                            <v-card rounded="" color="grey lighten-5">
                                <v-responsive :aspect-ratio="374 / 298" content-class="d-flex pa-20px">
                                    <v-img max-width="260" :aspect-ratio="260 / 132" src="/images/sub/solution/smartfarm/rmfarm-img4.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                            <div class="mt-20px mt-md-40px">
                                <tit-wrap-sprout>
                                    알엠팜 보급형
                                </tit-wrap-sprout>

                                <txt-item>
                                    <template #title>측정항목</template>
                                    실시간 무게, 급액량, 배액량
                                </txt-item>

                                <txt-item>
                                    <template #title>적용분야</template>
                                    파프리카, 토마토 등 배지기반 시설재배 작물
                                </txt-item>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card rounded="" color="grey lighten-5" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="800" :width="$vuetify.breakpoint.lgAndUp ? '800' : ''" :aspect-ratio="800 / 376" src="/images/sub/solution/smartfarm/rmfarm-img5.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        웹과 모바일 앱에서 쉽고 간편한 실시간 모니터링
                                        <template #text> 자체 개발 소프트웨어로 간편한 작동과 사용자 친화적인 인터페이스로 누구나 쉽게 사용할 수 있습니다. <br class="d-none d-lg-block" />PC, 태블릿, 모바일 등에서 원하는 정보 확인이 가능합니다. </template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/rmfarm-img6.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                특허등록
                                <template #text>
                                    식물 근권부 함수율 측정장치
                                </template>
                            </tit-wrap-small>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/rmfarm-img7.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                농업기계 목록집 등록
                                <template #text>
                                    식물 근권부 함수율 측정장치
                                </template>
                            </tit-wrap-small>
                        </v-col>
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="300">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/rmfarm-img8.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                혁신제품 등록
                                <template #text>
                                    조달청 혁신장터 전용몰 등록
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section id="rmfarm-portfolio" class="page-section--last">
            <template #title>
                포트폴리오
            </template>

            <div class="tabs-wrap">
                <v-tabs v-model="tab" hide-slider show-arrows centered center-active class="v-tabs--btn">
                    <u-tab to="#rmfarm-high-tab" id="rmfarm-high-tab">알엠팜 고급형</u-tab>
                    <u-tab to="#rmfarm-basic-tab" id="rmfarm-basic-tab">알엠팜 기본형</u-tab>
                    <u-tab to="#rmfarm-entry-tab" id="rmfarm-entry-tab">알엠팜 보급형</u-tab>
                </v-tabs>
            </div>

            <template #pageSectionImmersive>
                <div style="max-width:1480px" class="mx-auto px-12px">
                    <v-tabs-items v-model="tab" touchless>
                        <v-tab-item value="rmfarm-high-tab" transition="fade-transition" reverse-transition="fade-transition">
                            <rmfarm-high-slide />
                        </v-tab-item>
                        <v-tab-item value="rmfarm-basic-tab" transition="fade-transition" reverse-transition="fade-transition">
                            <rmfarm-basic-slide />
                        </v-tab-item>
                        <v-tab-item value="rmfarm-entry-tab" transition="fade-transition" reverse-transition="fade-transition">
                            <rmfarm-entry-slide />
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";
import RmfarmHighSlide from "@/pages/client/sub/solution/RmfarmHighSlide.vue";
import RmfarmBasicSlide from "@/pages/client/sub/solution/RmfarmBasicSlide.vue";
import RmfarmEntrySlide from "@/pages/client/sub/solution/RmfarmEntrySlide.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
        UTabs,
        UTab,
        RmfarmHighSlide,
        RmfarmBasicSlide,
        RmfarmEntrySlide,
    },
    props: {},
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
